export var VERSION = '2.11.3';
//# sourceMappingURL=version.js.map